var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500066 8.95933C0.366732 8.95933 0.240732 8.90733 0.146732 8.81267C-0.0479342 8.618 -0.0479342 8.30067 0.146732 8.10533L7.2934 0.960001C7.48207 0.770668 7.73273 0.666668 7.9994 0.666668C8.26673 0.666668 8.5174 0.770668 8.70607 0.958668L15.8534 8.10533C16.0481 8.3 16.0481 8.61733 15.8534 8.81267C15.7587 8.90733 15.6334 8.95933 15.5001 8.95933C15.3667 8.95933 15.2407 8.90733 15.1467 8.81267L8.00007 1.66667L0.853399 8.81267C0.759399 8.90733 0.633399 8.95933 0.500066 8.95933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.e040d2d2184de827b3b10f18f4baadd2.svg";
export { ForwardRef as ReactComponent };